import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from './base-modal.component';

export interface Project {
  id?: number;
  name: string;
  activities: Activity[];
}

export interface Activity {
  id?: number;
  name: string;
}

export interface ProjectSelectionDialogData {
  headerText?: string;
  closeButtonText?: string;
  actionButtonText?: string;
  projects: Project[];
  selectedProject?: Project;
  selectedActivity?: Activity;
}

export interface ProjectSelectionDialogResult {
  project: Project;
  activity: Activity;
}

@Component({
  selector: 'app-project-selection-modal',
  standalone: true,
  imports: [CommonModule],
  template: require('./project-selection-modal.component.html').default,
  styles: [
    require('!!raw-loader!sass-loader!./base-modal.component.scss').default,
    require('!!raw-loader!sass-loader!./project-selection-modal.component.scss').default,
  ],
  animations: [BaseModalComponent.modalAnimations[0]],
})
export class ProjectSelectionModalComponent extends BaseModalComponent {
  headerText?: string;
  closeButtonText?: string;
  actionButtonText?: string;
  projects: Project[] = [];
  selectedProject: Project | null = null;
  selectedActivity: Activity | null = null;

  configure(data: ProjectSelectionDialogData): void {
    this.headerText = data.headerText;
    this.closeButtonText = data.closeButtonText;
    this.actionButtonText = data.actionButtonText;
    this.projects = data.projects || [];
    this.selectedProject = data.selectedProject || null;
    this.selectedActivity = data.selectedActivity || null;
  }

  protected override focusFirstElement(): void {
    const firstInput = document.getElementById('project-select');
    if (firstInput) {
      firstInput.focus();
    }
  }

  onProjectSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const projectName = selectElement.value;

    if (projectName) {
      this.selectedProject = this.projects.find((p) => p.name === projectName) || null;
    } else {
      this.selectedProject = null;
    }

    // Reset activity when project changes
    this.selectedActivity = null;
  }

  onActivitySelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const activityName = selectElement.value;

    if (activityName && this.selectedProject) {
      this.selectedActivity =
        this.selectedProject.activities.find((a) => a.name === activityName) || null;
    } else {
      this.selectedActivity = null;
    }
  }

  canSave(): boolean {
    return !!(this.selectedProject && this.selectedActivity);
  }

  save(): void {
    if (this.canSave() && this.selectedProject && this.selectedActivity) {
      this.confirm({
        project: this.selectedProject,
        activity: this.selectedActivity,
      } satisfies ProjectSelectionDialogResult);
    }
  }
}
